<div style="padding: 15px;">
  <div
    class="upload-container"
    [ngClass]="{ 'is-loading': uploadState === 'loading', 'has-preview': uploadState === 'preview' }"
    appImageDragNDrop
    (filesChangeEmitter)="onFileChange($event)"
    (click)="fileInput.click()">

    <input type="file" #fileInput name="file" id="file" (change)="onFileChange($event.target.files)" accept="image/*" style="display: none;">

    <div class="state-ui">
      @switch (uploadState) {
        <!-- Initial State -->
        @case ('initial') {
          <div class="dropzone-content">
            <mat-icon class="upload-icon">cloud_upload</mat-icon>
            <p class="upload-text">Drag & drop or <span class="upload-link">browse</span></p>
          </div>
        }
        <!-- Preview and Loading State -->
        @case ('preview') {
          <div class="image-preview">
            <img [src]="thumbnailPreview" class="thumbnail">
            <div class="preview-overlay">
              <button mat-icon-button (click)="removeFile($event)" class="remove-btn">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        }
        @case ('loading') {
          <div class="image-preview">
            <img [src]="thumbnailPreview" class="thumbnail loading-img">
            <div class="loading-overlay">
              <mat-spinner diameter="40"></mat-spinner>
            </div>
          </div>
        }
        <!-- Error State -->
        @case ('error') {
          <div class="dropzone-content error-content">
            <mat-icon class="upload-icon">error</mat-icon>
            <p class="upload-text">Upload Failed. <span class="upload-link" (click)="retryUpload($event)">Try again.</span> [where: ImageUploadComponent.handleUploadError]</p>
          </div>
        }
      }
    </div>
  </div>
</div>
